"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Component = _interopRequireDefault(require("./Component"));

var _StoreComponent2 = _interopRequireDefault(require("../components/store/StoreComponent"));

var _GenericStore = require("../components/store/GenericStore");

var _WizardContextProvider = _interopRequireDefault(require("../context/WizardContextProvider"));

var _helpers = require("../helpers/helpers");

var _i18next = _interopRequireDefault(require("i18next"));

var _reactI18next = require("react-i18next");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var RenderForm = /*#__PURE__*/function (_StoreComponent) {
  (0, _inherits2["default"])(RenderForm, _StoreComponent);

  var _super = _createSuper(RenderForm);

  function RenderForm(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, RenderForm);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setI18n", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var form, languages;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              form = _this.props.form;
              languages = (0, _keys["default"])(form === null || form === void 0 ? void 0 : form.translations);

              if (!(languages && languages.length > 0)) {
                _context.next = 6;
                break;
              }

              _context.next = 5;
              return _i18next["default"].use(_reactI18next.initReactI18next).init({
                lng: 'de',
                fallbackLng: 'en',
                defaultNS: 'common',
                ns: 'common',
                debug: true,
                keySeparator: false,
                nsSeparator: false,
                interpolation: {
                  escapeValue: false // not needed for react as it escapes by default

                },
                react: {
                  wait: true
                }
              }, function (err, t) {
                if (err) return console.log('something went wrong loading', err);
                t('key'); // -> same as i18next.t
              });

            case 5:
              languages.forEach(function (lng) {
                return _i18next["default"].addResources(lng, 'common', form.translations[lng]);
              });

            case 6:
              _this.setState({
                i18nReady: true
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleSubmit", function () {
      var record = _GenericStore.dataStore.getValue(_this.path);

      if (!(record === null || record === void 0 ? void 0 : record.preconditionData) || !(0, _isArray["default"])(record.preconditionData)) record.preconditionData = [];

      _this.onSubmitWithPreconditionData(record, _this.props.onSubmit);
    });
    var _this$props = _this.props,
        _form = _this$props.form,
        nuggetPath = _this$props.nuggetPath,
        _this$props$isLogInAr = _this$props.isLogInArray,
        isLogInArray = _this$props$isLogInAr === void 0 ? false : _this$props$isLogInAr;
    _this.path = nuggetPath ? "/".concat(nuggetPath.split('.').join('/')).concat(_form.path) : _form.path;

    _this.addStoresAndPathes([{
      store: _GenericStore.dataStore,
      pathes: [_this.path]
    }]);

    if (isLogInArray) _GenericStore.dataStore.setValue(_this.path, {});
    _this.state = {
      i18nReady: false
    };
    return _this;
  }

  (0, _createClass2["default"])(RenderForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setI18n();
    }
  }, {
    key: "onSubmitWithPreconditionData",
    value: function onSubmitWithPreconditionData(record, onSubmit) {
      var _this$props$isLogInAr2 = this.props.isLogInArray,
          isLogInArray = _this$props$isLogInAr2 === void 0 ? false : _this$props$isLogInAr2;
      if (!isLogInArray) record.preconditionData = [];
      var valuesForPrecondition = (0, _helpers.getValuesForPrecondition)(record);
      if (valuesForPrecondition && (0, _isArray["default"])(valuesForPrecondition) && valuesForPrecondition.length > 0) record.preconditionData = valuesForPrecondition;
      onSubmit(record);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props$isLogInAr3 = this.props.isLogInArray,
          isLogInArray = _this$props$isLogInAr3 === void 0 ? false : _this$props$isLogInAr3;
      var _this$props2 = this.props,
          _this$props2$isAutoSa = _this$props2.isAutoSave,
          isAutoSave = _this$props2$isAutoSa === void 0 ? false : _this$props2$isAutoSa,
          _this$props2$onSubmit = _this$props2.onSubmit,
          onSubmit = _this$props2$onSubmit === void 0 ? function () {
        return null;
      } : _this$props2$onSubmit;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(RenderForm.prototype), "componentWillUnmount", this).call(this);

      if (isAutoSave && isLogInArray) {
        this.handleSubmit();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          formComponents = _this$props3.form.content,
          _this$props3$isAutoSa = _this$props3.isAutoSave,
          isAutoSave = _this$props3$isAutoSa === void 0 ? false : _this$props3$isAutoSa,
          _this$props3$isLogInA = _this$props3.isLogInArray,
          isLogInArray = _this$props3$isLogInA === void 0 ? false : _this$props3$isLogInA,
          _this$props3$isPrecon = _this$props3.isPreconditionData,
          isPreconditionData = _this$props3$isPrecon === void 0 ? false : _this$props3$isPrecon;

      if (!this.state.i18nReady) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_WizardContextProvider["default"], {
        path: this.path
      }, formComponents.map(function (component) {
        return /*#__PURE__*/_react["default"].createElement(_Component["default"], {
          block: component,
          parentPath: _this2.path,
          key: _this2.path,
          onSubmit: _this2.handleSubmit,
          isAutoSave: isAutoSave,
          isLogInArray: isLogInArray,
          isPreconditionData: isPreconditionData,
          successfullySubmitted: _this2.props.successfullySubmitted
        });
      })));
    }
  }]);
  return RenderForm;
}(_StoreComponent2["default"]);

RenderForm.propTypes = {
  onSubmit: _propTypes["default"].func.isRequired,
  form: _propTypes["default"].object.isRequired,
  successfullySubmitted: _propTypes["default"].bool
};
var _default = RenderForm;
exports["default"] = _default;